module.exports = __webpack_public_path__ + "static/media/vinted.3dcf8b02.png";